import { http } from "../httpHandler";
import { FollowupEmailTemplateEntity, TServerErrorResponse } from "@/types";
import { links } from "@/constants";

export const GET_FOLLOW_UP_EMAIL_TEMPLATES = "GET_FOLLOW_UP_EMAIL_TEMPLATES";

export const createFollowUpEmailTemplate = async (
  data: Pick<FollowupEmailTemplateEntity, "template">,
) => {
  try {
    const response = await http.post<FollowupEmailTemplateEntity>(
      links.followUpEmailTemplate.index,
      data,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateFollowUpEmailTemplate = async (
  id: string,
  data: Pick<FollowupEmailTemplateEntity, "template">,
) => {
  try {
    const response = await http.patch<FollowupEmailTemplateEntity>(
      links.followUpEmailTemplate.followUpEmailTemplateById(id),
      data,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getFollowUpEmailTemplate =
  async (): Promise<FollowupEmailTemplateEntity> => {
    try {
      const response = await http.get<FollowupEmailTemplateEntity>(
        links.followUpEmailTemplate.index,
      );
      return response.data;
    } catch (error) {
      throw error as TServerErrorResponse;
    }
  };

export const deleteFollowUpEmailTemplate = async (id: string) => {
  try {
    const response = await http.delete<FollowupEmailTemplateEntity>(
      links.followUpEmailTemplate.followUpEmailTemplateById(id),
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
